import HmacMD5 from 'crypto-js/hmac-md5';

/**
 * 整理其他工具方法
 */

export const getHostName = val => {
  let url = val || (window && window.location && window.location.hostname ? window.location.hostname : '');
  if (url) {
    if (url.indexOf('http://') !== -1) {
      url = url.substring(7, url.length);
    } else if (url.indexOf('https://') !== -1) {
      url = url.substring(8, url.length);
    }
  }
  return url;
};

export const getp = p => {
  return HmacMD5(p, '7NEkojNzfkk=').toString();
};

// 银行卡号显示*****
export const displayCardcode = (payNo, len, num) => {
  let str1 = '*';
  len = len || 4;
  payNo = payNo + '';
  num = num || 8;
  const reg = new RegExp('(.{' + len + '})(.*)(.{' + len + '})');
  payNo = payNo.replace(reg, str => {
    return str.slice(0, len) + str1.repeat(num) + str.slice(str.length - len, str.length);
  });
  return payNo;
};

// 小数点精度（）
export const fixFloat = num => {
  let m = 0;
  let s1 = num.toString();
  try {
    m += s1.split('.')[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return Number(s1.replace('.', '')) / Math.pow(10, m);
};

// 扩展数组方法:删除指定元素
export const arrayRemove = (arr, val) => {
  let index = arr.indexOf(val);
  while (index > -1) {
    arr.splice(index, 1);
    index = arr.indexOf(val);
  }
  return arr;
};

// 游戏黑名单过滤
export const blackListFilter = (response, blackListGame, custName) => {
  let obj = null;
  if (response && blackListGame) {
    let banGameInfo = {
      isBanUser: false,
      blacklistGame: [],
    };
    blackListGame.split(';').map(blacklistItem => {
      let currentArr = blacklistItem.split(',');
      if (custName === currentArr[0]) {
        banGameInfo.isBanUser = true;
        banGameInfo.blacklistGame = currentArr.filter((cItem, cIndex) => cIndex);
      }
    });
    if (banGameInfo.isBanUser && banGameInfo.blacklistGame.length) {
      obj = response.filter(
        i =>
          !banGameInfo.blacklistGame.filter(
            banItem => Number(i.play_id) === Number(banItem) || Number(i.id) === Number(banItem)
          ).length
      );
    } else {
      obj = response;
    }
  } else {
    obj = response;
  }
  return obj;
};

// url转对象
export const getUrlParams = url => {
  if (!url) {
    url = location.href;
  }
  let obj = {};
  try {
    url = url.match(/\?([^#]+)/)[1];
    let arr = url.split('&');
    for (let i = 0; i < arr.length; i++) {
      let subArr = arr[i].split('=');
      let key = decodeURIComponent(subArr[0]);
      obj[key] = decodeURIComponent(subArr[1]);
    }
    return obj;
  } catch (e) {
    return obj;
  }
};
// 对象转url
export const parseUrlParams = data => {
  try {
    let tempArr: any[] = [];
    for (let i in data) {
      let key = encodeURIComponent(i);
      let value = encodeURIComponent(data[i]);
      tempArr.push(key + '=' + value);
    }
    return tempArr.join('&');
  } catch (e) {
    return '';
  }
};

// export const openWebsite = url => {
//   // 1. 直接尝试 window.open()
//   let newWindow = window.open(url, "_blank");
//
//   // 2. Safari 可能拦截，尝试用 a 标签模拟
//   if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
//     const link = document.createElement("a");
//     link.href = url;
//     link.target = "_blank";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   }
// };

/**
 * 打开三方网址
 */
export const openWebsite = url => {
  // if (typeof url !== 'string' || !url.startsWith('http')) {
  //   console.error('Invalid URL provided');
  //   return;
  // }
  // setTimeout(() => {
  //   window.open(url, '_blank');
  // }, 0);
  // 创建一个链接元素
  const link = document.createElement('a');
  link.href = url;
  // 在新标签页中打开
  link.target = '_blank';
  // 增加安全性
  link.rel = 'noopener noreferrer';

  // 模拟点击链接元素
  document.body.appendChild(link);

  try {
    setTimeout(() => {
      link.click();
    }, 0);
  } catch (error) {
    console.error('Failed to open the link:', error);
  } finally {
    // 移除链接元素
    setTimeout(() => {
      document.body.removeChild(link);
    }, 0);
  }
};

export const winOpen = (url: string) => {
  openWebsite(url);
  // setTimeout(() => {
  //   window.open(url, '_blank');
  // }, 0);
};
